import { render } from "./DefaultViewLayout.vue?vue&type=template&id=88729f18&scoped=true"
import script from "./DefaultViewLayout.vue?vue&type=script&lang=js"
export * from "./DefaultViewLayout.vue?vue&type=script&lang=js"

import "./DefaultViewLayout.vue?vue&type=style&index=0&id=88729f18&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88729f18"]])

export default __exports__